import React from 'react';
import Navbar from './header';
import Footer from './footer';
import Home from './home';
import {Switch,Route} from 'react-router-dom';
import BlockHome from './shared/BlockHome';
import Services from './pages/Services';
import Blog from './pages/Blog';
import BlogPage from './pages/BlogPage';

const Layout = () => {
    return (
        <>
        <Navbar />
        <BlockHome />
        <div className="main_content">
        <div className="main_content_container">
         <Switch>
             <Route exact path={'/'} component={Home} />
             <Route exact path={'/sub_services'} component={Services} />
             <Route exact path={'/blogs'} component={Blog} />
             <Route exact path={`/blogs/:blogId`} component={BlogPage} />
         </Switch>
         </div>
         </div>
        <Footer />
        </>
    )
};
export default Layout;